import { Component, Inject, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'toc',
    template: `<div *ngIf="sections?.length">
  <h4 id="wikiPageViewCont">
    <i class="glyphicon glyphicon-log-in" style="margin-right: .5em"></i>
    <span translate>Contents</span>
  </h4>
  <div class="contents-container" 
      *ngFor="let item of sections" 
      (click)="scrollTo(item.ref)" href>
      <div [ngClass]="item.type">{{ item.title }}</div>
  </div>
</div>`
})
export class ContentsComponent {
    @Input() title: string;
    @Input() tocSource: string;

    sections: any[];

    constructor(@Inject(DOCUMENT) private document: Document) { }

    ngAfterViewInit(): void {
        if (this.tocSource && !this.sections) {
            setTimeout(
                () => { this.sections = this.getHeadings(this.tocSource); },
                250
            );
        }
    }

    scrollTo(element: HTMLElement): void {
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    private getHeadings(id: string): any[] {
        const container = this.document.querySelector(id);
        if (!container) return [];

        const list = container.querySelectorAll("h1,h2,h3,h4,h5,h6");
        let ret = [];
        list.forEach(
            (h) => {
                ret.push({
                    title: h.textContent,
                    ref: h,
                    type: h.tagName.toLowerCase()
                });
            }
        );
        return ret;
    }
}
